import AdaptAdjustableSystem from "@inter-ikea-storagetwo/range/dist/systems/AdaptAdjustableSystem";
import { HierarchyUtils } from "@inter-ikea-core/core";
import { getConnectorsComponent } from "@inter-ikea-storagetwo/range/dist/functions/componentGetters";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
import { ADJUSTABLE_CONNECTOR } from "@inter-ikea-storagetwo/range/dist/constants";
import { RIGHT_ATTACH_TO_CLOTH_RAIL_CONNECTOR } from "../constants/connectorKeys";
import { adjustSize, getAdjustableMoveablePart, } from "@inter-ikea-storagetwo/range/dist/functions/adjustable";
import { CONNECTOR_DOESNT_EXISTS } from "@inter-ikea-storagetwo/range/dist/constants/errors";
export default class AdaptBoaxelAdjustableSystem extends AdaptAdjustableSystem {
    constructor() {
        super();
    }
    onRemoveComponent(_entity, _oldComponent) {
        super.onRemoveComponent(_entity, _oldComponent);
        const rightShelf = getAdjustableMoveablePart(_entity);
        const hostConnector = getConnectorsComponent(rightShelf).getConnectorByKey(RIGHT_ATTACH_TO_CLOTH_RAIL_CONNECTOR);
        if (!hostConnector)
            throw new Error(CONNECTOR_DOESNT_EXISTS);
        const children = HierarchyUtils.descendants(_entity).filter((child) => child.hasComponent(COMPONENT_IDS.ADJUSTABLE_COMPONENT));
        children.forEach((child) => adjustSize(child, ADJUSTABLE_CONNECTOR, rightShelf, hostConnector));
    }
}
